import { Vector3Tuple } from 'three'
import { Roof, Wall, WallSegment } from './types'

function approximatelyTheSame(a: Vector3Tuple, b: Vector3Tuple, epsilon: number = 0.1) {
  return Math.abs(a[0] - b[0]) < epsilon && Math.abs(a[1] - b[1]) < epsilon && Math.abs(a[2] - b[2]) < epsilon
}

export function updateRoofs(
  segments: Record<string, WallSegment>,
  walls_: Record<string, Wall>,
  roofs: Record<string, Roof>
) {
  const walls = Object.values(walls_)
  const ret: Roof[] = []

  for (const roofID in roofs) {
    const roof = roofs[roofID]
    const wall = walls.find(wall => wall.roofId === roofID)

    if (wall === undefined) {
      continue
    }

    const points = wall.segments.map(segment => segments[segment].startPoint)
    points.push(segments[wall.segments[wall.segments.length - 1]].endPoint)

    const expectedRoofPoints = points.map<[number, number, number]>(pt => [pt.x, pt.y, roof.height])

    const lengthIsTheSame = roof.perimeterPoints.length === expectedRoofPoints.length

    const isTheSame =
      lengthIsTheSame &&
      roof.perimeterPoints.every((point, idx) => approximatelyTheSame(point, expectedRoofPoints[idx]))

    if (isTheSame) {
      continue
    }

    ret.push({
      ...roof,
      perimeterPoints: expectedRoofPoints,
    })
  }

  return ret
}
